module.exports = __webpack_public_path__ + "02fb70b5af4c548727d7f86ebfc73996.MP3";